import React from 'react';

import { AlertTitle, Alert } from '@mui/material';

export const PermissionDenied: React.FC = () => {
  return (
    <Alert severity='error'>
      <AlertTitle>Permission Denied</AlertTitle>
      You do not have the required permissions to load this page.
    </Alert>
  );
};
